import React from 'react';
import { Box } from '@mui/material';
import DosenTooltip from '../../../../../components/ui/DosenTooltip';

// Outlined CTA pill used by the lesson-editor sections (AI Reasoning, Improve with AI, etc.).
const ActionPill: React.FC<{
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** Shown on hover while disabled (e.g. "Run Improve with AI to generate reasoning"). */
  disabledTooltip?: string;
  testId?: string;
}> = ({ icon, label, onClick, disabled = false, disabledTooltip, testId }) => {
  const pill = (
    <Box
      component="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      data-testid={testId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        // Disabled reads dark with dim text rather than faded.
        background: disabled ? 'rgba(0, 0, 0, 0.2)' : 'transparent',
        border: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
        borderRadius: '6px',
        px: 1.5,
        py: 0.75,
        cursor: disabled ? 'default' : 'pointer',
        color: disabled ? '#565656' : 'var(--Text-text-primary, #FDFDFD)',
        fontFamily: 'Inter',
        fontSize: 12,
        fontWeight: 500,
        '&:hover': { borderColor: disabled ? 'var(--Stroke-Border-border-dim, #2A2A2A)' : 'var(--Stroke-highlight, #F79420)' }
      }}
    >
      {icon}
      {label}
    </Box>
  );

  // Tooltip needs a wrapper span — a disabled button swallows pointer events.
  return disabled && disabledTooltip ? (
    <DosenTooltip title={disabledTooltip}>
      <Box component="span" sx={{ display: 'inline-flex', cursor: 'default' }}>
        {pill}
      </Box>
    </DosenTooltip>
  ) : (
    pill
  );
};

export default ActionPill;
